export default __webpack_public_path__ + "static/media/Iconly_Bulk_Filter.56b2177a.svg";